import { useTranslation } from "react-i18next";
import { Link, useHistory, useLocation } from "react-router-dom";
import { InputField } from "../components/_input/_input";
import { FormButton } from "../components/_input/_button";
// import PhoneDropDown from "../components/_input/_phoneDropDown";
import { useState, useRef, useEffect } from "react";
import crypto from "crypto-js";
import Joi from "joi";
import { toast } from "react-toastify";
import { formValidate, GetMessages } from "../utils/validation";
import axios from "axios";
import config from "../configuration/config";
// import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { saveData, User_Data_Key } from "../utils/localStorageManager";
import { useUserFavorite } from "./hooks/useUserFavorite";
import * as journifyTrackingUserEvents from "../services/trackingUserEvents";
import useTrackViewLoginScreenOnce from "../hooks/useTrackViewLoginScreen";

const OTPInput = ({ value, onChange, onComplete, error }) => {
  const [otpStr, setOtpStr] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  // Auto focus on mount
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 4);
    setOtpStr(val);
    onChange(val);

    if (val.length === 4) {
      onComplete(val);
      inputRef.current?.blur();
    }
  };

  const handleContainerClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="otp-container" dir="ltr" onClick={handleContainerClick} style={{ position: 'relative', cursor: 'text' }}>
      {/* Real input - now visible but positioned absolutely */}
      <input
        ref={inputRef}
        type="text"
        autoComplete="one-time-code"   // CRITICAL for iOS
        name="one-time-code"
        inputMode="numeric"
        value={otpStr}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        maxLength={4}
        autoFocus
        pattern="[0-9]*"
        enterKeyHint="done"
        className="real-otp-input"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          opacity: 0.01,           // Changed from 1 to 0.01
          color: '#000',            // Changed from transparent to #000
          caretColor: '#000',       // Changed from transparent to #000
          background: 'transparent',
          border: 'none',
          outline: 'none',
          zIndex: 10,
          fontSize: '16px',
        }}
      />

      {/* Visual fake boxes */}
      <div className={`otp-inputs ${error ? 'has-error' : ''}`}>
        {[0, 1, 2, 3].map((index) => {
          const char = otpStr[index] || '';
          const isActiveBox = isFocused && (index === otpStr.length || (index === 3 && otpStr.length === 4));

          return (
            <div
              key={index}
              className={`otp-field fake-otp-box ${isActiveBox ? 'is-active' : ''}`}
            >
              {char}
            </div>
          );
        })}
      </div>
      {error && <div className="otp-error-text">{error}</div>}
    </div>
  );
};
export default function SignIn({ onTabChange, onLogin, redirectURL }) {
  const { init } = useUserFavorite();
  const bodyRef = useRef(null);
  const { t: trans, i18n } = useTranslation(["common", "form", "model", "error2"]);
  let lang = i18n.language || "ar";
  const languageDir = "language-" + lang;
  const tabsList = [
    {
      tab: 1,
      title: "sign-in",
    },
    {
      tab: 2,
      title: "sign-up",
    },
    {
      tab: 3,
      title: "reset-password",
    },
    {
      tab: 4,
      title: "login-validation",
    },
  ];
  const [isSending, setIsSending] = useState(false);
  const EMAIL_KEY = "Email",
    PHONE_KEY = "PhoneNumber",
    IDENTITY_KEY = "IdentityNo";
  const history = useHistory();
  const location = useLocation();
  const [requestForm, setRequestForm] = useState({
    email: null,
    phoneNumber: null,
    identityNo: null,
    password: null,
    confirm: "", // Initialize as empty string for OTP
  });
  const [enterType, setEnterType] = useState(PHONE_KEY);
  const [confirmPhoneNumber, setConfirmPhoneNumber] = useState(false);
  useEffect(() => {
    // هذا مهم جداً: نخلق حقل OTP مخفي من البداية عشان iOS يمسك عليه
    const hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('autocomplete', 'one-time-code');
    hiddenInput.setAttribute('type', 'text');
    hiddenInput.setAttribute('inputmode', 'numeric');
    hiddenInput.style.position = 'absolute';
    hiddenInput.style.opacity = '0';
    hiddenInput.style.height = '0';
    hiddenInput.style.pointerEvents = 'none';
    document.body.appendChild(hiddenInput);

    return () => {
      document.body.removeChild(hiddenInput);
    };
  }, []);
  // Schema for 4-digit OTP
  let schemaConfirm = Joi.object().keys({
    phoneNumber: Joi.string().min(10).messages(GetMessages()),
    confirm: Joi.string().required().messages(GetMessages()),
  });

  let schema = Joi.object()
    .keys({
      email: Joi.string()
        .email({ minDomainSegments: 2, tlds: { allow: false } })
        .messages(GetMessages())
        .optional(),
      phoneNumber: Joi.string().min(10).messages(GetMessages()).optional(),
      // identityNo: Joi.string().min(8).messages(GetMessages()).optional(),
      password: Joi.string().required().messages(GetMessages()),
      confirm: Joi.string().allow('').optional(), // Allow empty string for OTP flow init
    })
    .or("email", "phoneNumber", "identityNo")
    .required();

  let schemaphoneNumber = Joi.object().keys({
    phoneNumber: Joi.string().min(10).messages(GetMessages()),
  });

  let schemaidentityNo = Joi.object().keys({
    identityNo: Joi.string().min(8).messages(GetMessages()),
  });

  const [error, setError] = useState({});
  const [unifiedInput, setUnifiedInput] = useState("");

  const handleUnifiedChange = (e) => {
    let val = e.target.value;
    setUnifiedInput(val);

    let type = PHONE_KEY;
    if (/[a-zA-Z@]/.test(val)) {
      type = EMAIL_KEY;
    } else {
      let cleanVal = val.replace(/\D/g, ''); // all digits
      if (cleanVal.length === 10 && (cleanVal.startsWith('1') || cleanVal.startsWith('2')) && !val.startsWith('+')) {
        type = IDENTITY_KEY;
      } else if (cleanVal.length === 10 && cleanVal.startsWith('05')) {
        type = PHONE_KEY; // phone with 0
      } else if (cleanVal.length === 9) {
        type = PHONE_KEY;
      } else if (val.startsWith('+')) {
        type = PHONE_KEY;
      } else {
        // default fallback
        type = PHONE_KEY;
        if (cleanVal.length === 10) type = IDENTITY_KEY;
      }
    }


    if (type !== enterType) {
      setEnterType(type);
      setConfirmPhoneNumber(false);
    }

    let newForm = { ...requestForm };
    newForm.email = null;
    newForm.phoneNumber = null;
    newForm.identityNo = null;

    if (type === EMAIL_KEY) {
      newForm.email = val;
    } else if (type === PHONE_KEY) {
      let formattedPhone = val;
      let cleanVal = val.replace(/\D/g, '');
      if (cleanVal.length === 9 && !val.startsWith('+')) {
        formattedPhone = `+966${cleanVal}`;
      } else if (cleanVal.length === 10 && cleanVal.startsWith('05')) {
        formattedPhone = `+966${cleanVal.substring(1)}`;
      } else if (cleanVal.length === 12 && cleanVal.startsWith('966')) {
        formattedPhone = `+${cleanVal}`;
      }
      newForm.phoneNumber = formattedPhone;
    } else if (type === IDENTITY_KEY) {
      newForm.identityNo = val;
    }
    setRequestForm(newForm);
  };

  // We need ref in this, because we are dealing
  // with JS setInterval to keep track of it and
  // stop it when needed
  const Ref = useRef(null);
  const [timer, setTimer] = useState("00:00:00");
  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };
  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer((hours > 9 ? hours : "0" + hours) + ":" + (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds));
    }
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer("00:02:00");

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };
  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 120);
    return deadline;
  };

  const handleManualLogin = (otpVal) => {
    const currentOtp = otpVal || requestForm.confirm;
    if (currentOtp.length < 4) return;

    const result = formValidate(schemaConfirm, { phoneNumber: requestForm.phoneNumber, confirm: currentOtp }) ?? {};
    setError(result);
    if (Object.keys(result).length > 0) return;

    if (isSending) return;
    setIsSending(true);

    axios
      .post(`${config.controllURL}api/Administration/MatchedKeysNoValidationKey`, {
        AccessType: PHONE_KEY,
        Access: requestForm.phoneNumber,
        ValidationKey: currentOtp,
      })
      .then((response) => {
        setIsSending(false);
        if (response.status === 200 && response.data && typeof response.data === 'object') {
          let userrespons = response?.data;
          userrespons["identityImage"] = "";
          saveData(User_Data_Key, userrespons, true);
          saveData("isAuthenticated", true, false);
          saveData("secretKey", response.data.id.toString().split("_")[0], false);

          journifyTrackingUserEvents.trackIdentify(userrespons);
          journifyTrackingUserEvents.trackLogin("phone_otp");

          if (onLogin) onLogin();
          init();

          if (redirectURL) {
            setTimeout(() => {
              window.location.href = redirectURL;
            }, 1000);
          }
          const redirect = new URLSearchParams(location.search).get("redirect");
          if (redirect) history.push(redirect);
        } else {
          toast.error(lang === 'ar' ? "كود التحقق غير صحيح" : "Invalid verification code");
        }
      })
      .catch((err) => {
        setIsSending(false);
        toast.error(trans("error2:validation_error"));
        console.log(err);
      });
  };

  const handleRequest = () => {
    console.log("handleRequest");
    const result = formValidate(schema, requestForm) ?? {};
    const errorResult = removeUnspecificError(result);
    setError(errorResult);
    try {
      if (Object.keys(errorResult).length === 0) {
        setIsSending(true);
        axios
          .post(`${config.controllURL}api/Administration/SignInValidate1`, {
            AccessType: enterType,
            Access: enterType === EMAIL_KEY ? requestForm.email.trim().toLowerCase() : enterType === PHONE_KEY ? requestForm.phoneNumber : requestForm.identityNo.trim().toLowerCase(),
            Password: crypto.MD5(requestForm.password).toString(),
          })
          .then((response) => {
            setIsSending(false);
            if (response.status === 200) {
              saveData(User_Data_Key, response.data, true);
              saveData("isAuthenticated", true, false);
              saveData("secretKey", response.data.id.toString().split("_")[0], false);

              journifyTrackingUserEvents.trackIdentify(response.data);
              journifyTrackingUserEvents.trackLogin(enterType === EMAIL_KEY ? "email" : "identity_no");

              if (onLogin) onLogin();
              init();

              const redirect = new URLSearchParams(location.search).get("redirect");
              if (redirect) history.push(redirect);
            }
          })
          .catch((error) => {
            setIsSending(false);
            if (error.response && error.response.status === 400) {
              toast.error(trans("common:failed-access"));
            }
          });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const removeUnspecificError = (errorList) => {
    let errorResult = {};
    Object.assign(errorResult, errorList);
    if (errorList) {
      for (let index = 0; index < Object.keys(errorList).length; index++) {
        const key = Object.keys(errorList)[index];
        if (enterType.toLowerCase() === key.toLowerCase()) {
          continue;
        } else {
          if (key.toLowerCase() === "password") continue;
          delete errorResult[key];
        }
      }
    }
    return errorResult;
  };
  const removeUnspecific2Error = (errorList) => {
    let errorResult = {};
    Object.assign(errorResult, errorList);
    if (errorList) {
      for (let index = 0; index < Object.keys(errorList).length; index++) {
        const key = Object.keys(errorList)[index];
        if (enterType.toLowerCase() === key.toLowerCase()) {
          continue;
        } else {
          delete errorResult[key];
        }
      }
    }
    return errorResult;
  };
  const handleSendVerificationCode = () => {
    var sch = schemaidentityNo;
    if (enterType === PHONE_KEY) {
      sch = schemaphoneNumber;
    }
    const result = formValidate(sch, requestForm) ?? {};
    const errorResult = removeUnspecific2Error(result);
    setError(errorResult);
    var codeValid = false;
    if (Object.keys(errorResult).length === 0) {
      setIsSending(true);
      axios
        .post(config.controllURL + "api/Administration/SendSms", {
          AccessType: enterType,
          Access: enterType === PHONE_KEY ? requestForm.phoneNumber : requestForm.identityNo,
        })
        .then((response) => {
          setIsSending(false);
          if (response?.data === false) {
            toast.error(trans("common:failed-access"));
          } else {
            if (response.data) {
              codeValid = true;
              clearTimer(getDeadTime());
              if (enterType === IDENTITY_KEY) {
                const val = { ...requestForm };
                val.phoneNumber = response.data;
                setRequestForm(val);
              }
            } else {
              toast.error(trans("error2:no_phone_number_error"));
            }
          }

          if (codeValid) {
            setConfirmPhoneNumber(true);
          }
        })
        .catch((err) => {
          setIsSending(false);
          toast.error(trans("common:failed-access"));
          console.log(err);
        });
    }
  };
  // handleLogin was replaced by handleManualLogin for OTP

  //ارسال لمنصة التسويق
  useTrackViewLoginScreenOnce({
    isOpen: true,
    active: true,
    payload: { source: "sign_in_component" },
  });
  return (
    <div ref={bodyRef} className="flex flex-col w-100">
      <div className="flex flex-col items-start justify-start w-full mb-8 mobile-hide-title">
        <h1 className="w-full text-start text-3xl text-bold mb-2 mt-0" style={{ color: '#0aa15f', fontWeight: '800' }}>
          {confirmPhoneNumber
            ? (lang === 'ar' ? 'كود التحقق' : 'Verification Code')
            : (lang === 'ar' ? 'سجل دخولك' : trans("form:sign-in"))}
        </h1>
        <p className="w-full text-start text-13 mt-0 opacity-80" style={{ lineHeight: '1.5', maxWidth: '400px' }}>
          {confirmPhoneNumber
            ? (lang === 'ar'
              ? 'الرجاء إدخال كود التحقق الذي تم إرساله إليك للمتابعة.'
              : 'Please enter the verification code sent to you to continue.')
            : (lang === 'ar'
              ? 'يمكنك تسجيل الدخول باستخدام رقم الهاتف، أو البريد الإلكتروني، أو رقم الهوية'
              : 'You can sign in using your phone number, email, or identity number')}
        </p>
      </div>
      <div className={`popup-content flex flex-col ${languageDir}`}>
        {!confirmPhoneNumber && (
          <div className="mt-4">
            <InputField
              type="text"
              errorLabel={error?.email || error?.phoneNumber || error?.identityNo}
              value={unifiedInput}
              onChangeValue={handleUnifiedChange}
              placeholder={`${trans("form:identity-no")} / ${trans("form:phone")} / ${trans("form:email")}`}
            />
          </div>
        )}

        {enterType === EMAIL_KEY ? (
          <div className={`forget-password-content my-5 ${languageDir}`}>
            <InputField
              type="password"
              errorLabel={error?.password}
              value={requestForm.password}
              onChangeValue={(e) => {
                const val = { ...requestForm };
                val.password = e.target.value;
                setRequestForm(val);
              }}
              placeholder={trans("common:password")}
            />

            <Link className="forget-password-link text-24 text-center text-flex opacity-80" onClick={() => onTabChange(tabsList[2])}>
              {trans("common:forget-password")}
            </Link>
          </div>
        ) : (
          confirmPhoneNumber && (
            <div className="otp-wrapper mt-4">
              <OTPInput
                error={error?.confirm}
                value={requestForm.confirm}
                onChange={(otp) => {
                  const val = { ...requestForm };
                  val.confirm = otp;
                  setRequestForm(val);
                }}
                onComplete={(otp) => {
                  handleManualLogin(otp);
                }}
              />

              <div className="timer-display text-center mt-6">
                <span className={`timer-box ${timer === "00:00:00" ? 'expired' : ''}`}>
                  {timer}
                </span>
                {timer === "00:00:00" && (
                  <button
                    className="resend-link"
                    onClick={handleSendVerificationCode}
                  >
                    {lang === 'ar' ? 'إعادة الإرسال' : 'Resend Code'}
                  </button>
                )}
              </div>
            </div>
          )
        )}

        {(!confirmPhoneNumber || (enterType === EMAIL_KEY)) && (
          <div className="flex flex-row items-center justify-center nice-flex-space-between nice-gap-1rem mt-10 auth-popup-actions">
            <Link
              className="text-24 text-center text-block font-bold border-b opacity-80"
              style={{ color: 'currentColor', borderColor: 'currentColor' }}
              onClick={() => {
                onTabChange(tabsList[1]);
              }}>
              {trans("common:no-account")}
            </Link>

            <FormButton
              isPrimary={true}
              name={trans("form:sign-in")}
              icon={true}
              onClick={() => {
                if (isSending === false) {
                  setTimeout(() => {
                    if (enterType === EMAIL_KEY) {
                      handleRequest();
                    } else if (enterType === PHONE_KEY || enterType === IDENTITY_KEY) {
                      if (confirmPhoneNumber) {
                        handleManualLogin();
                      } else {
                        handleSendVerificationCode();
                      }
                    }
                  }, 500);
                }
              }}
              isLoading={isSending}
              classes={" px-10 py-5 text-20 border-sm"}
            />
          </div>
        )}
      </div>
    </div>
  );
}